import { lazy } from "react";
import Loadable from "components/Loadable";

// Lazy-loaded components
const List = Loadable(lazy(() => import("pages/standards/molecules/List")));

const RecordsRoute = [
  {
    path: "records",
    children: [
      {
        path: "view",
        element: (
          <List
            moduleType="record"
            limit={30}
            name="Records"
            navigateUrl="format-detail"
            isFormat={true}
          />
        )
      }
    ]
  }
];

export default RecordsRoute
